/**
 * We'll use this mixin to handle group oriented mixins and functionality.
 */

const AmazeCardMethods = {};

// Default Max Length.
AmazeCardMethods.maxLength = 100;
AmazeCardMethods.postfix = "...";

/**
 * Create a summary of ofText with maxLength.
 * @param {*} ofText
 * @param {*} maxlength
 * @returns
 */
AmazeCardMethods.createSummary = (ofText, maxlength = AmazeCardMethods.maxLength) => {
  return ofText
    .replace(/(<(\/)?(em|strong|span|u)>)/gi, "") // Remove text format.
    .replace(/(<([^>]+)>)/gi, " ") // Replace all other html tags with white space.
    .replace(/  +/g, ' ') // Remove extraneous white space.
    .substring(0, maxlength) // Limit characters.
    .trim(); // Remove start/end white space.
}

export default {
  methods: {
    createSummary(ofText, maxLength = AmazeCardMethods.maxLength, postfix = AmazeCardMethods.postfix) {
      const summary = AmazeCardMethods.createSummary(ofText, (1 + maxLength - postfix.length));
      return summary && summary.length ? summary + postfix : null;
    }
  }
};
